if (!customElements.get('chelsea-color-selector')) {
  customElements.define(
    'chelsea-color-selector',
    class ChelseaColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-chelsea')) return;

        this.productId = this.dataset.productId;
        this.storageKey = `chelsea-color-selection-${this.productId}`;
        
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.assetBaseUrl = this.colorTableUrl.substring(0, this.colorTableUrl.lastIndexOf('/') + 1);
        this.colorData = null;
        this.currentTonalita = null;

        // Elementi UI
        this.inputGroup = this.querySelector('.chelsea-input-group');
        this.colorInputDisplay = this.querySelector('.chelsea-color-display');
        this.colorInputReal = this.querySelector('.chelsea-color-real');
        this.selectedPreviewContainer = this.querySelector('.chelsea-selected-preview');
        this.toggleBtn = this.querySelector('.chelsea-toggle-btn');
        this.clearBtn = this.querySelector('.chelsea-clear-btn');
        
        // Elementi Modale
        this.modalOverlay = this.querySelector('.chelsea-modal-overlay');
        this.modalCloseBtn = this.querySelector('.chelsea-modal-close');
        this.modalVariantName = this.querySelector('.chelsea-modal-variant-name');
        this.colorSwatchContainer = this.querySelector('.color-swatch-container');

        this.initialize();
      }

      disconnectedCallback() {
        document.removeEventListener('chelsea:variant-change', this.handleVariantChange);
      }

      async initialize() {
        this.setupEventListeners();
        
        setTimeout(() => {
            const variantSelector = document.getElementById(this.closest('section').querySelector('.product-variant-selects').id);
            if (variantSelector) {
                const selectedElements = variantSelector.querySelectorAll('input:checked, option:checked');
                const values = Array.from(selectedElements).map(el => el.value).join(' ');
                this.handleVariantChange({ detail: { variantValue: values } });
            } else {
                this.updateToggleButton();
            }
        }, 100);

        try {
          await this.fetchColorData();
          this.restoreSelection();
          if (this.currentTonalita) {
            this.renderColorSwatches();
          }
        } catch (error) {
          console.error('Chelsea Color Selector: Initialization failed', error);
          if (this.toggleBtn) this.toggleBtn.textContent = 'Errore nel caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        try {
          const response = await fetch(this.colorTableUrl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          this.colorData = await response.json();
        } catch (error) {
          console.error('Error fetching color data:', error);
          throw error;
        }
      }

      setupEventListeners() {
        this.handleVariantChange = this.handleVariantChange.bind(this);
        document.addEventListener('chelsea:variant-change', this.handleVariantChange);

        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (event) => {
          if (event.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorSwatchContainer.addEventListener('click', (event) => {
          const swatch = event.target.closest('.color-swatch');
          if (swatch) {
            this.updateSelection(swatch.dataset.colorName);
            this.closeModal();
          }
        });
      }

      handleVariantChange(event) {
        const variantValue = event.detail.variantValue.toUpperCase();
        let newTonalita = null;
        
        if (variantValue.includes('ORO')) newTonalita = 'ORO';
        else if (variantValue.includes('ARGENTO')) newTonalita = 'ARGENTO';
        else if (variantValue.includes('ACCIAIO')) newTonalita = 'ACCIAIO';
        
        if (newTonalita !== this.currentTonalita) {
          this.currentTonalita = newTonalita;
          const savedColor = sessionStorage.getItem(this.storageKey);
          if (!savedColor) {
             this.clearSelection();
          }
          
          this.updateToggleButton();
          this.renderColorSwatches();
        }
      }
      
      updateSelection(colorName) {
        this.colorInputReal.value = colorName;
        sessionStorage.setItem(this.storageKey, colorName);
        this.renderSelectedPreview(colorName);
      }

      clearSelection() {
        this.colorInputReal.value = '';
        sessionStorage.removeItem(this.storageKey);
        this.selectedPreviewContainer.innerHTML = '';
        this.inputGroup.classList.remove('has-selection');
      }

      restoreSelection() {
        const savedColor = sessionStorage.getItem(this.storageKey);
        if (savedColor && this.colorData) {
           this.updateSelection(savedColor);
        }
      }

      renderSelectedPreview(colorName) {
        if (!this.colorData) return;
        
        const color = this.colorData.colori.find(c => c.codice === colorName);
        
        if (!color) {
            console.warn(`Colore ${colorName} non trovato nei dati.`);
            this.clearSelection();
            return;
        }

        const imageUrl = this.assetBaseUrl + color.path;

        this.inputGroup.classList.add('has-selection');
        this.selectedPreviewContainer.innerHTML = `
            <div class="color-swatch" style="background-image: url('${imageUrl}'); width: 100%; height: 100%; cursor: default;" title="${color.codice}">
                <div class="color-swatch-inner" style="width: 100%;">
                    ${color.codice}
                </div>
            </div>
        `;
      }

      updateToggleButton() {
        if (this.currentTonalita) {
          this.toggleBtn.textContent = `Mostra Tabella Colori ${this.currentTonalita}`;
          this.toggleBtn.disabled = false;
        } else {
          this.toggleBtn.textContent = 'Seleziona una finitura';
          this.toggleBtn.disabled = true;
        }
      }

      openModal() {
        if (!this.currentTonalita || !this.modalOverlay) return;
        document.body.style.overflow = 'hidden';
        this.modalVariantName.textContent = this.currentTonalita;
        this.modalOverlay.classList.add('is-visible');
      }

      closeModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = '';
        this.modalOverlay.classList.remove('is-visible');
      }

      renderColorSwatches() {
        if (!this.colorData || !this.colorSwatchContainer) return;
        
        if (!this.currentTonalita) {
            this.colorSwatchContainer.innerHTML = '';
            return;
        }

        const filteredColors = this.colorData.colori.filter(
          (color) => color.tonalita && color.tonalita.toUpperCase() === this.currentTonalita
        );

        this.colorSwatchContainer.innerHTML = '';

        if (filteredColors.length === 0) {
          this.colorSwatchContainer.innerHTML = '<p style="padding:10px; width:100%;">Nessun colore trovato per questa finitura.</p>';
          return;
        }

        filteredColors.forEach((color) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          
          const imageUrl = this.assetBaseUrl + color.path;
          swatch.style.backgroundImage = `url('${imageUrl}')`;

          swatch.dataset.colorName = color.codice;
          swatch.title = `${color.codice}`;

          const swatchInner = document.createElement('div');
          swatchInner.className = 'color-swatch-inner';
          swatchInner.innerHTML = `
            ${color.codice}
          `;
          swatch.appendChild(swatchInner);

          this.colorSwatchContainer.appendChild(swatch);
        });
      }
    }
  );
}
